module.exports = __webpack_public_path__ + "static/img/favicon.4bc2142.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon.png
// module id = ZURh
// module chunks = 1